import Vue from 'vue';
import GenericMixin from '../mixins/GenericMixin';
import TextsMixin from '../mixins/TextsMixin';

Vue.mixin(GenericMixin);
Vue.mixin(TextsMixin);

